import { ComponentPropsWithRef, forwardRef } from "react";
import clsx from "clsx";
import IcoClose from "../../assets/img/IcoClose";
import CloseStyle from "./css/Close.module.css";
import { motion, useAnimationControls} from "framer-motion";

type CloseProps = ComponentPropsWithRef<"button"> & {
    /** 버튼 크기 (px) */
    size?: "sm" | "md" | "lg";
    /** wave 효과 활성화 여부 */
    wave?: boolean;
    /** 아이콘 색상 */
    iconColor?: string;
    /** hover 시 wave 색상 */
    waveColor?: "gray" | "red" | "dark";
};

const sizeMap = {
    sm: 28,
    md: 36,
    lg: 44,
};

const Close = forwardRef<HTMLButtonElement, CloseProps>(({
    size = "md",
    wave = true,
    iconColor,
    waveColor = "gray",
    className,
    style,
    ...props
}, ref) => {
    const buttonSize = sizeMap[size];
    
    const controls = useAnimationControls();

    const handleMouseEnter = () => {
        // 마우스 올리면 현재 회전값 0으로 초기화 후 한 바퀴 돌기
        controls.set({ rotate: 0 });
        controls.start({ rotate: 180, transition: { duration: 0.7, ease: "easeInOut" } });
    };

    return (
        <motion.div
            animate={controls}
        >
            <button
                type="button"
                ref={ref}
                className={clsx(
                    CloseStyle.closeButton,
                    wave && CloseStyle.waveEnabled,
                    waveColor && CloseStyle[`wave-${waveColor}`],
                    className
                )}
                style={{
                    width: buttonSize,
                    height: buttonSize,
                    ...style,
                }}
                onMouseEnter={handleMouseEnter}
                aria-label="닫기"
                {...props}
            >
                {/* Wave layers */}
                {wave && (
                    <>
                        <span className={clsx(CloseStyle.waveRing, CloseStyle.ring1)} />
                        <span className={clsx(CloseStyle.waveRing, CloseStyle.ring2)} />
                        <span className={clsx(CloseStyle.waveRing, CloseStyle.ring3)} />
                    </>
                )}
                <span className={CloseStyle.iconWrapper} style={{ color: iconColor }}>
                    <IcoClose />
                </span>
            </button>
        </motion.div>
    );
});

Close.displayName = "Close";

export default Close;
export type { CloseProps };
